import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";

import HardDriveIcon from "assets/icons/hard_drive.svg?react";

import styles from "./styles.module.scss";

// Okno modalne ostrzegające o kończącym się miejscu na dysku (90–99%).
// Wygląd wg projektu Figma ("Zbliżasz się do końca miejsca na dysku — 90%").
const DiskSpaceLowModal = ({
  onRemindLater,
  onIncreaseSpace,
}: {
  onRemindLater: () => void;
  onIncreaseSpace: () => void;
}) => {
  const { t } = useTranslation();

  return ReactDOM.createPortal(
    <div className={styles.modal} onClick={onRemindLater}>
      <div className={styles.wrapper} onClick={(e) => e.stopPropagation()}>
        <div className={styles.content}>
          <div className={styles.icon}>
            <HardDriveIcon />
          </div>
          <div className={styles.title}>{t("diskSpaceModal.lowTitle")}</div>
          <div className={styles.body}>{t("diskSpaceModal.lowBody")}</div>
        </div>

        <div className={styles.actions}>
          <button className={styles.secondaryBtn} onClick={onRemindLater}>
            {t("diskSpaceModal.remindLater")}
          </button>
          <button className={styles.primaryBtn} onClick={onIncreaseSpace}>
            {t("diskSpaceModal.increaseSpace")}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DiskSpaceLowModal;
